import { PostComment } from "@/components/Ticket/MessageInputBox";
import { axios } from "@/lib/axios";

interface GetTicketParams {
  data_id?: number;
  customer_id?: number;
}

export const getTicket = (params: GetTicketParams) => {
  return axios.get("/api/v1/dataTickets/getTicket", {
    params: { ...params },
  });
};

export const postComment = (postData: PostComment) => {
  return axios.post("/api/v1/dataTickets/postComment", postData);
};

export const searchTicket = (
  projectCategoryId: number,
  keyword: string | null = null,
  area_id: number | null = null,
  block_id: number | null = null
) => {
  return axios.get("/api/v1/dataTickets/searchTicket", {
    params: {
      project_category_id: projectCategoryId,
      area_id: area_id,
      block_id: block_id,
      keyword: keyword,
    },
  });
};

interface TemporarySaveParams {
  user_id: number;
  data_ticket_id: number;
}

interface TemporarySaveData {
  user_id: number;
  data_ticket_id: number;
  comment?: string;
}

export const getTemporarySave = (params: TemporarySaveParams) => {
  return axios.get("/api/v1/dataTicketSaveTemporaries/get", {
    params: { ...params },
  });
};

export const postTemporarySave = (postData: TemporarySaveData) => {
  return axios.post("/api/v1/dataTicketSaveTemporaries/post", postData);
};

interface CancelScheduledMailParams {
  data_ticket_comment_id: number;
}

export const cancelScheduledMail = (params: CancelScheduledMailParams) => {
  return axios.post("/api/v1/dataTickets/cancelScheduledMail", params);
};

interface PreviewCommentMailData {
  comment: string;
  ticket_destinations_id: number;
  is_inquiry_user: boolean;
  created_by: number;
  data_ticket_id: number;
  customer_id?: number;
  data_id?: number;
}

export const previewCommentMail = (postData: PreviewCommentMailData) => {
  return axios.post("/api/v1/dataTickets/previewCommentMail", postData);
};
